import classes from "./Backdrop.module.css";

export default function Backdrop() {
  return <div className={classes.backdrop}></div>;
}
